import request from '@/utils/request'
import api from '@/config/api'
const platform = localStorage.getItem('platform')

export function getAdvertisers(data, type) {
    let url = `/${platform}/advertisers/${type}`
    return request.get(url, data)
}

export function updateAdvertiser(data, type) {
    const url = `/${platform}/advertisers/${type}/${data.id}`
    return request.patch(url, data)
}

export function deleteAdvertisers(ids, type) {
    ids = ids instanceof Array ? ids.join(',') : ids
    return request.delete(`/${platform}/advertisers/${type}/${ids}`)
}

export function pullAdvertisers(data, type) {
    const token = localStorage.getItem('token')
    let url = `${api.baseUrl}/${platform}/advertisers/sync_${type}?account_id=${data.account_id}&token=${token}`
    if (data.oauth_type) {
        url += `&oauth_type=${data.oauth_type}`
    }
    return url
}

export function getAdvertiserCosts(data) {
    let url = `/${platform}/advertisers/${data.id}/costs`
    return request.get(url, data)
}

export function getKsAdvertiserBalanceTransferRecords(advertiserId, data) {
    let url = `/${platform}/advertisers/${advertiserId}/ks_balance_transfer_records`
    return request.get(url, data)
}

export function bindWork(data, ids) {
    const method = 'post'
    const url = `/${platform}/advertisers/bind_worker`

    if(!(ids instanceof Array)){
        ids = [ids]
    }

    return request[method](url, {'ids':ids ,'worker_id': data.worker_id })
}

export function syncCost(data) {
    const url = `/${platform}/advertisers/sync_cost`
    return request.post(url, data)
}

export function fillCost(data) {
    const url = `/${platform}/advertisers/fill_cost`
    return request.post(url, data)
}

export function createApp(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/create_app`
    return request[method](url, data)
}

export function getAdvertiserWechatApplets(data) {
    let url = `/${platform}/advertisers/${data.id}/wechatapps`
    return request.get(url, data)
}

export function pullWechatApp(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/pull_wechatapp`
    return request[method](url, data)
}

export function getAdvertiserAnchors(data) {
    let url = `/${platform}/advertisers/${data.id}/anchors`
    return request.get(url, data)
}

export function pullAnchor(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/pull_anchor`
    return request[method](url, data)
}

export function createAnchor(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/create_anchor`
    return request[method](url, data)
}

export function storeAvatar(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/store_avatar`
    return request[method](url, data)
}

export function pullAvatar(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/pull_avatar`
    return request[method](url, data)
}

export function createPt(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/create_pt`
    return request[method](url, data)
}

export function syncLandingPage(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/sync_landing_page`
    return request[method](url, data)
}

export function handsel(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/handsel`
    return request[method](url, data)
}

export function syncAdCallbackConfig(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/sync_ad_callback_config`
    return request[method](url, data)
}

export function pullEventAsset(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/pull_event_asset`
    return request[method](url, data)
}

export function createEventAsset(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/create_event_asset`
    return request[method](url, data)
}

export function createAndroidEventAsset(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/create_android_event_asset`
    return request[method](url, data)
}

export function storeOrUpdateAdvertiserTask(data) {
    const method = 'post'
    const url = `/${platform}/advertisers/advertiser_tasks`
    return request[method](url, data)
}

export function uploadFile(data) {
    const url = `/${platform}/advertisers/upload`
    return request.post(url, data)
}

export function updateBudget(data, ids) {
    const method = 'post'
    const url = `/${platform}/advertisers/update_budget`

    if(!(ids instanceof Array)){
        ids = [ids]
    }

    return request[method](url, {'ids':ids ,'budget': data.budget })
}

export function updateRemark(data, ids) {
    const method = 'post'
    const url = `/${platform}/advertisers/update_remark`

    if(!(ids instanceof Array)){
        ids = [ids]
    }

    return request[method](url, {'ids':ids ,'remark': data.remark })
}

export function unbindWork(data, ids) {
    const method = 'post'
    const url = `/${platform}/advertisers/unbind_worker`

    if(!(ids instanceof Array)){
        ids = [ids]
    }

    return request[method](url, {'ids':ids ,'worker_id': data.worker_id })
}

export function getExportCsv(data, type) {
    let url = `/${platform}/advertisers/${type}/export`
    return request.get(url, data)
}

export function updateLabel(data, ids) {
    const method = 'post'
    const url = `/${platform}/advertisers/update_label`

    if(!(ids instanceof Array)){
        ids = [ids]
    }

    return request[method](url, {'ids':ids ,'label': data.label })
}

export function getAdvertiserCampaigns(data) {
    const url = `/${platform}/media_campaigns`
    return request.get(url, data)
}

export function pullAdvertiserCampaigns(data) {
    const method = 'post'
    const url = `/${platform}/media_campaigns/pull`
    return request[method](url, data)
}

export function deleteAdvertiserCampaigns(data) {
    const method = 'post'
    const url = `/${platform}/media_campaigns/delete`
    return request[method](url, data)
}

export function deleteAllAdvertiserCampaigns(data) {
    const method = 'post'
    const url = `/${platform}/media_campaigns/delete_all`
    return request[method](url, data)
}
